module.exports = __webpack_public_path__ + "static/media/gold-tier-person.03d2e9e6.svg";